import { render } from "./PSkeleton.vue?vue&type=template&id=834ce048"
import script from "./PSkeleton.vue?vue&type=script&lang=js"
export * from "./PSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "/builds/sqMDsSTzB/0/dsp/plazkart-interface/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__